export default function formLabel({ variables, }) {
    return {
        MuiFormLabel: {
            styleOverrides: {
                root: {
                    color: variables.text_primary,
                    fontSize: variables.type_body_sm_font_size,
                    fontWeight: variables.font_weight_semibold,
                    marginBottom: variables.spacing_02,
                    "&.Mui-disabled": {
                        color: variables.text_medium,
                    },
                    "&.MuiInputLabel-outlined": {
                        "&.MuiInputLabel-formControl": {
                            transform: `translate(${variables.spacing_04}, calc((${variables.component_height_medium} - 1.4375em) / 2)) scale(1)`,
                        },
                        "&.MuiInputLabel-formControl.MuiInputLabel-shrink, &.MuiInputLabel-formControl.MuiInputLabel-sizeSmall.MuiInputLabel-shrink": {
                            transform: "translate(14px, -7px) scale(0.75)",
                        },
                        "&.MuiInputLabel-formControl.MuiInputLabel-sizeSmall": {
                            transform: `translate(${variables.spacing_04}, calc((${variables.component_height_small} - 1.4375em) / 2)) scale(1)`,
                        },
                    },
                    "&.MuiInputLabel-filled": {
                        "&.MuiInputLabel-formControl": {
                            transform: `translate(${variables.spacing_04}, calc((${variables.component_height_medium} - 1.4375em) / 2)) scale(1)`,
                        },
                        "&.MuiInputLabel-formControl.MuiInputLabel-shrink, &.MuiInputLabel-formControl.MuiInputLabel-sizeSmall.MuiInputLabel-shrink": {
                            transform: "translate(14px, -7px) scale(0.75)",
                        },
                        "&.MuiInputLabel-formControl.MuiInputLabel-sizeSmall": {
                            transform: `translate(${variables.spacing_04}, calc((${variables.component_height_small} - 1.4375em) / 2)) scale(1)`,
                        },
                    },
                    "&.MuiInputLabel-standard": {
                        "&.MuiInputLabel-formControl": {
                            transform: "translate(0, 24px) scale(1)",
                        },
                        "&.MuiInputLabel-formControl.MuiInputLabel-shrink, &.MuiInputLabel-formControl.MuiInputLabel-sizeSmall.MuiInputLabel-shrink": {
                            transform: "translate(0, -1.5px) scale(0.75)",
                        },
                        "&.MuiInputLabel-formControl.MuiInputLabel-sizeSmall": {
                            transform: "translate(0, 21px) scale(1)",
                        },
                    },
                },
                asterisk: {
                    color: variables.required_field_asterisk,
                },
            },
        },
    };
}
//# sourceMappingURL=formLabel.js.map